import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next, useTranslation } from 'react-i18next';
import odigeoCMS from './processor';
import { Config } from '../Config';

export const CMS = ({ id, values, dangerouslySetInnerHTML }) => {
    const { t } = useTranslation();

    if (dangerouslySetInnerHTML) {
        return <span dangerouslySetInnerHTML={{ __html: t(id, values) }} />;
    }

    return t(id, values);
};

CMS.Init = ({ lng, brand }) => {
    const rawVersionedPath = Config.get('versionedByReleasePath') || '';
    const versionedByReleasePath = (rawVersionedPath.match(/versioned_[^/]+|_versionedByRelease_/) || [''])[0];
    const rootPath = window.location.host !== 'localhost:3000' ? `/frontend-home/static-content/${versionedByReleasePath}` : '';
    const path = `${rootPath}/locales/${brand}/${lng}.json`;

    i18n.use(odigeoCMS)
        .use(HttpApi)
        .use(initReactI18next)
        .init({
            backend:
                {
                    loadPath: path,
                    allowMultiLoading: false,
                    crossDomain: false,
                },
            lng,
            debug: false,
            fallbackLng: false,
            load: 'languageOnly',
            postProcess: ['OdigeoCMS'],
            interpolation: {
                escapeValue: false,
            },
        });
    // TODO: remove when CONTENT-11314 is fixed
    i18n.services.pluralResolver.addRule('ar', {
        numbers: [0, 1, 2, 3, 11, 100],
        plurals: function arabicPlurals(n) {
            return Number(n !== 1);
        },
    });
    i18n.services.pluralResolver.addRule('ru', {
        numbers: [0, 1, 5],
        plurals: function russianPlurals(n) {
            return Number(n !== 1);
        },
    });
    // ENDTODO: remove when CONTENT-11314 is fixed
};

CMS.propTypes = {
    id: PropTypes.string.isRequired,
    values: PropTypes.object,
};

CMS.defaultProps = {
    values: {},
};
